module.exports = __webpack_public_path__ + "static/media/kelaibo3.bda47ed1.png";